import { useEffect, useRef } from 'react'

/**
 * Custom hook to reset row selections when a specific filter field changes
 * @param {Array} searchArr - Array of filter objects containing field and value
 * @param {Object} resetSelectionRef - Ref object that contains the resetSelection function
 * @param {string} filterField - The field name to monitor for changes (default: 'orderType')
 */
export const useResetSelectionOnFilterChange = (searchArr, resetSelectionRef, filterField = 'orderType') => {
  // Track previous filter value to detect changes
  const prevFilterValueRef = useRef(null)

  useEffect(() => {
    // Find the filter for the specified field
    const filter = searchArr?.find(item => item.field === filterField)
    const currentFilterValue = filter?.value

    // If filter value changed from previous value, reset selections
    if (prevFilterValueRef.current !== null && prevFilterValueRef.current !== currentFilterValue) {
      // Reset row selections
      if (resetSelectionRef?.current) {
        resetSelectionRef.current()
      }
    }

    // Update ref with current value
    prevFilterValueRef.current = currentFilterValue
  }, [searchArr, resetSelectionRef, filterField])
}

